import VueComponent from './lib/vue-easy-print.vue'
export function install(Vue) {
  Vue.component(VueComponent.name, VueComponent)
  /* -- Add more components here -- */
}
export default VueComponent




//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-easy-print/src/index.js
// module id = null
// module chunks = 